import { VEHICLE_TYPE_ENUM, AD_TYPE_ENUM, SYSTEM } from 'utils/constants'
import { cleanString } from 'utils/utils'
import { config } from 'config/config.js'
import uniq from 'lodash/uniq'
import { difference, isEqual } from 'lodash'

export function getTag(model) {
  let _lifeStyle = getLifeStyle(
    model && model.Filters ? model.Filters : undefined
  )

  let _parameters = getParameters(model)

  let _phrasesSeo = getPhrasesSeo(
    _parameters,
    model.FilterCustom.TipoVeiculo,
    _lifeStyle
  )

  if (
    (_phrasesSeo != undefined && !_phrasesSeo.Title) ||
    !_phrasesSeo.Description
  ) {
    if (config.system == SYSTEM.WEBMOTORS) {
      _phrasesSeo.Title = `${
        model.FilterCustom.TipoVeiculo == VEHICLE_TYPE_ENUM.CAR
          ? 'Carros Novos e Usados em Todo o Brasil'
          : 'Motos Novas e Usadas em Todo o Brasil'
      }`
      _phrasesSeo.Description =
        model.FilterCustom.TipoVeiculo == VEHICLE_TYPE_ENUM.CAR
          ? 'Procurando por Carros? Na Webmotors você encontra o maior estoque de veículos com as melhores ofertas do mercado. Acesse e confira!'
          : 'Procurando por Motos? Na Webmotors você encontra o maior estoque de veículos com as melhores ofertas do mercado. Acesse e confira!'
      _phrasesSeo.H1 =
        model.FilterCustom.TipoVeiculo == VEHICLE_TYPE_ENUM.CAR
          ? 'Carros Novos e Usados em Todo o Brasil'
          : 'Motos Novas e Usadas em Todo o Brasil'
    }
  }
  _phrasesSeo.Title = `${
    _phrasesSeo != undefined && _phrasesSeo.Title ? _phrasesSeo.Title : ''
  }`
  return _phrasesSeo
}

function getParameters(model) {
  let _parameters = []

  switch (model.FilterCustom.TipoAnuncio) {
    case AD_TYPE_ENUM.NEW:
      _parameters.push({
        TipoAnuncio:
          model.FilterCustom.TipoVeiculo == VEHICLE_TYPE_ENUM.CAR
            ? 'novos'
            : 'novas',
      })
      break
    case AD_TYPE_ENUM.USED:
      _parameters.push({
        TipoAnuncio:
          model.FilterCustom.TipoVeiculo == VEHICLE_TYPE_ENUM.CAR
            ? 'usados e seminovos'
            : 'usadas e seminovas',
      })
      break
    default:
      _parameters.push({
        TipoAnuncio:
          model.FilterCustom.TipoVeiculo == VEHICLE_TYPE_ENUM.CAR
            ? 'usados, seminovos e novos'
            : 'usadas, seminovas e novas',
      })
      break
  }

  if (model.FilterCustom.Location) {
    let _locations = []

    model.FilterCustom.Location.map(item => {
      if (!item.Cidade) _locations.push(item.Estado)
      else _locations.push(`${item.Cidade}/${item.Abbr}`)
    })
    _parameters.push({ Localizacao: _locations.join(',') })
  }

  if (model.FilterCustom.Veiculos) {
    if (model.FilterCustom.Veiculos.length == 1) {
      let _vehicle = model.FilterCustom.Veiculos[0]
      _parameters.push({
        Veiculo: `${cleanString(_vehicle.Marca, {
          toLowerCase: 1,
          capitalizeAll: 1,
        })}${
          _vehicle.Modelo
            ? ' ' +
              cleanString(_vehicle.Modelo, { toLowerCase: 1, capitalizeAll: 1 })
            : ''
        }${
          _vehicle.Versao
            ? ' ' +
              cleanString(_vehicle.Versao, { toLowerCase: 1, capitalizeAll: 1 })
            : ''
        }`,
      })

      if (_vehicle.Marca) {
        _parameters.push({
          Marca: cleanString(_vehicle.Marca, {
            toLowerCase: 1,
            capitalizeAll: 1,
          }),
        })
      }

      if (_vehicle.Modelo) {
        _parameters.push({
          Modelo: cleanString(_vehicle.Modelo, {
            toLowerCase: 1,
            capitalizeAll: 1,
          }),
        })
      }

      if (_vehicle.Versao) {
        _parameters.push({
          Versao: cleanString(_vehicle.Versao, {
            toLowerCase: 1,
            capitalizeAll: 1,
          }),
        })
      }
    } else {
      let _vehicles = []
      model.FilterCustom.Veiculos.map(item => {
        _vehicles.push(
          `${cleanString(item.Marca, { toLowerCase: 1, capitalizeAll: 1 })}${
            item.Modelo
              ? ' ' +
                cleanString(item.Modelo, { toLowerCase: 1, capitalizeAll: 1 })
              : ''
          }`
        )
      })
      _parameters.push({ Veiculo: _vehicles.join(',') })
    }
  }

  if (
    model.FilterCustom.CorPrimaria &&
    model.FilterCustom.CorPrimaria.length > 0
  ) {
    if (model.FilterCustom.CorPrimaria[0])
      _parameters.push({ Cor: model.FilterCustom.CorPrimaria[0].Cor })
  }

  if (
    model.FilterCustom.NumeroDePortas &&
    model.FilterCustom.NumeroDePortas.length > 0
  ) {
    if (model.FilterCustom.NumeroDePortas[0])
      _parameters.push({ Portas: model.FilterCustom.NumeroDePortas[0] })
  }

  let _anoDe = model.FilterCustom.AnoDe ? parseInt(model.FilterCustom.AnoDe) : 0
  let _anoAte = model.FilterCustom.AnoAte
    ? parseInt(model.FilterCustom.AnoAte)
    : 0
  if (_anoDe != _anoAte) {
    if (_anoDe > 0) _parameters.push({ AnoDe: _anoDe })
    if (_anoAte > 0) _parameters.push({ AnoAte: _anoAte })
  } else if (_anoDe > 0) _parameters.push({ Ano: _anoDe })
  if (model.Count > 0) _parameters.push({ NOfertas: model.Count })

  return _parameters
}

/**
 * Extrai os parametros de uma string
 *
 * Input: `{Veiculo} do {AnoDe} até {AnoAte}`
 * Result: ['Veiculo', 'AnoDe', 'AnoAte']
 *
 * @param {*} input
 * @returns
 */
function extractParamsFromString(input) {
  const regex = /{([^}]+)}/g

  const matches = input.matchAll(regex)

  return Array.from(matches, match => match[1])
    .map(item => item.toLowerCase())
    .sort()
}

/**
 * Obtem as frases que serão utilizadas para SEO
 *
 * @param {*} parameters
 * @param {*} vehicleType
 * @param {*} lifeStyle
 * @returns
 */

const titleDescriptionCar = require('seo/title-description-carro-webmotors.json')
const titleDescriptionBike = require('seo/title-description-moto-webmotors.json')

function _getPhrasesSeo(parameters, vehicleType, lifeStyle) {
  if (parameters.length === 0) {
    return { Title: '', Description: '', H1: '' }
  }

  const jsonTemplate =
    vehicleType == VEHICLE_TYPE_ENUM.CAR
      ? titleDescriptionCar
      : titleDescriptionBike

  const paramsObj = parameters.reduce((a, b = {}) => ({ ...b, ...a }))

  const input = Object.keys(paramsObj)
    .map(item => item.toLocaleLowerCase())
    .sort()

  let bestFit = null
  let bestFitDiff = 0

  // Algoritimo para achar qual das opções de texto é a que se
  // encaixa melhor com a descricao
  for (const template of jsonTemplate.list) {
    const descriptionParams = extractParamsFromString(template.description)
    const titleParams = extractParamsFromString(template.title)
    const params = uniq([...titleParams, ...descriptionParams]).sort()

    if (isEqual([...params], [...input])) {
      bestFit = { ...template }
    }

    if (difference([...params], [...input]).length === 0) {
      const currentDiff = input.length - params.length

      if (currentDiff <= bestFitDiff || !bestFit) {
        bestFit = { ...template }
        bestFitDiff = currentDiff
      }
    }
  }

  // Caso não encontre nenhum fit, retorna o template padrão
  if (!bestFit) {
    return { Title: '', Description: '', H1: '' }
  }

  // Substitui os paramteros
  for (const key in paramsObj) {
    bestFit.description = bestFit.description.replace(
      `{${key}}`,
      paramsObj[key]
    )
    bestFit.title = bestFit.title.replace(`{${key}}`, paramsObj[key])
  }

  return {
    Description: bestFit.description,
    Title: bestFit.title,
    H1: bestFit.title,
  }
}

function getPhrasesSeo(parameters, vehicleType, lifeStyle) {
  return _getPhrasesSeo(parameters, vehicleType, lifeStyle)

  /** IMPLEMENTAÇÃO LEGADA
  var _json =
    vehicleType == VEHICLE_TYPE_ENUM.CAR
      ? require('seo/title-description-carro-webmotors.json')
      : require('seo/title-description-moto-webmotors.json')

  let _regex = new RegExp('\\{[a-zA-Z0-9\\-_]{1,}\\}', 'g')
  let _matches = undefined
  let _ret = true
  let _newDescription = '',
    _newTitle = '',
    _newH1 = ''
  let _nOfertas = ''

  if (_json.list && _json.list.length > 0) {
    for (var i = 0; i < _json.list.length; i++) {
      let item = _json.list[i]

      let _elmOfertasIndex = ''

      parameters.map((value, index) => {
        Object.keys(value).forEach(key => {
          if (key == 'NOfertas') {
            _elmOfertasIndex = index
            _nOfertas = value[key]
          }
        })
      })

      if (_elmOfertasIndex) {
        parameters.splice(_elmOfertasIndex, 1)
      }

      _matches = [...new Set(`${item.title} ${item.description}`.match(_regex))]
      _matches = _matches.filter(item => item !== '{NOfertas}')

      if (parameters.length == _matches.length) {
        _ret = true
        _newDescription = item.description
        _newTitle = item.title
        _newH1 = item.title
        let _setKeyCarros = false

        if (_nOfertas) {
          parameters.push({ NOfertas: _nOfertas })
          _nOfertas = ''
        } else {
          parameters.push({ NOfertas: 0 })
          _nOfertas = 0
        }

        parameters.map(value => {
          let _key = undefined
          let _value = undefined
          let _regPrm = ''
          Object.keys(value).forEach(key => {
            _key = key
            _value = value[key]
            _regPrm = new RegExp(`{${key}}`, 'ig')
          })

          if (!_setKeyCarros && lifeStyle) {
            _setKeyCarros = true

            let _lifeStyleMai = getDescriptionLifeStyle(lifeStyle, true)
            _newDescription = _newDescription.replace('Carros', _lifeStyleMai)
            _newTitle = _newTitle.replace('Carros', _lifeStyleMai)
            _newH1 = _newH1.replace('Carros', _lifeStyleMai)

            let _lifeStyleMin = getDescriptionLifeStyle(lifeStyle, false)
            _newDescription = _newDescription.replace('carros', _lifeStyleMin)
            _newTitle = _newTitle.replace('carros', _lifeStyleMin)
            _newH1 = _newH1.replace('carros', _lifeStyleMin)
          }

          let _strPrm = `${item.title} ${item.description}`

          if (_regPrm.test(_strPrm) || _key == 'NOfertas') {
            if (lifeStyle && _key == 'Veiculo')
              _value = getDescriptionLifeStyle(lifeStyle, true)

            _newDescription = _newDescription.replace(_regPrm, _value)
            _newTitle = _newTitle.replace(_regPrm, _value)
            _newH1 = _newH1.replace(_regPrm, _value)
          } else {
            _ret = false
            return
          }
        })

        if (_ret) {
          _newTitle = _newTitle
            .replace(new RegExp(/[-]?[ ]?novos e usados/gi), '')
            .replace(new RegExp(/[-]?[ ]?novas e usadas/gi), '')
            .trim()

          return {
            Title: _newTitle,
            Description: _newDescription,
            H1: _newH1,
          }
        }
      }
    }
  }

  return { Title: '', Description: '', H1: '' }
  **/
}

export function getLifeStyle(filters) {
  if (filters && filters.length > 0) {
    let _listAux = filters.filter(x => {
      return x.name == 'LifeStyle'
    })
    if (
      _listAux &&
      _listAux[0] &&
      _listAux[0].items &&
      _listAux[0].items.length
    ) {
      let _objAux = _listAux[0].items.filter(item => {
        return item.selected
      })

      if (_objAux && _objAux.length == 1) return _objAux[0].name
      return undefined
    }
  }
  return undefined
}

export function getDescriptionLifeStyle(lifeStyle, maiusculo) {
  if (CategoriaWithout.includes(lifeStyle)) return `${lifeStyle}`
  else if (!lifeStyle.includes('Carros'))
    return `${maiusculo ? 'Carros' : 'carros'} para ${lifeStyle}`
  else return `${lifeStyle}`
}

const CategoriaWithout = [
  'sedans',
  'suvs',
  'jipes',
  'conversiveis',
  'hatches',
  'primeiro carro',
  'picapes',
]
